var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaterMeter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 38H26V45H22V38Z",
    fill: "#8D6E63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 5C37 5 31 3 24 3C17 3 11 5 11 5C11 5 8 6.001 8 8V10V29V33C8 33 8 40 15 40C22 40 26 40 33 40C40 40 40 33 40 33V29V10V8C40 6.001 37 5 37 5Z",
    fill: "#EE8003"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 37H23C21.343 37 20 38.344 20 40H28C28 38.344 26.657 37 25 37Z",
    fill: "#D8D8D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9H36V26H12V9Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 19.5C20 17.291 24 11.5 24 11.5C24 11.5 28 17.291 28 19.5C28 21.709 26.21 23.5 24 23.5C21.79 23.5 20 21.709 20 19.5Z",
    fill: "#3677F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23 34C23 34.553 22.553 35 22 35H13C12.447 35 12 34.553 12 34V30C12 29.447 12.447 29 13 29H22C22.553 29 23 29.447 23 30V34ZM36 34C36 34.553 35.553 35 35 35H26C25.447 35 25 34.553 25 34V30C25 29.447 25.447 29 26 29H35C35.553 29 36 29.447 36 30V34Z",
    fill: "#8D6E63"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterMeter);
export default __webpack_public_path__ + "static/media/water-meter.f475f596fcc071b226ebaabcfb31adf4.svg";
export { ForwardRef as ReactComponent };